<div class="layout-container" (click)="onWrapperClick()"
     [ngClass]="{'layout-menu-horizontal': app.horizontal,
                'layout-menu-active': menuActive,
                'layout-top-small': app.topbarSize === 'small',
                'layout-top-medium': app.topbarSize === 'medium',
                'layout-top-large': app.topbarSize === 'large', 'p-ripple-disabled': !app.ripple, 'p-input-filled': app.inputStyle === 'filled'}"
                [class]="app.topbarColor + ' ' + app.menuColor">
    <div class="layout-top">
        <app-topbar></app-topbar>
        <div class="layout-topbar-separator"></div>
        <app-breadcrumb></app-breadcrumb>
    </div>
    <div class="layout-content">
        <router-outlet></router-outlet>
    </div>
    <app-config></app-config>
    <div class="layout-mask" *ngIf="menuActive" [@mask-anim]="'visible'"></div>
    <app-footer></app-footer>
    <div class="layout-config-mask" *ngIf="configDialogActive" [@mask-anim]="'visible'"></div>
</div>